angular.module("vgresiduos").directive("destinationArrival", function () {
	return {
		scope: true,
		controller: "DestinationArrivalCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/stages/destinationArrival/destinationArrival_template.html"
	};
});
